<template>
    <v-form ref="form" @submit="submit" v-model="formValid" class="call-configs">
        <div class="title-config">
            <div class="title">{{ $f.tc('campaignInfo') }}</div>
            <div class="btn-custom" @click="submit">{{ $f.tc('save') }}</div>
        </div>
        <div class="fci-scrollbar config-content">
            <div class="label">{{ $f.tc('title') }}</div>
            <v-text-field
                v-model="model.title"
                :rules="formRules.required"
                class="input-custom"
            ></v-text-field>
            <div class="label mt-12">{{ $f.tc('currentBot') }}</div>
            <div class="display-flex align-center">
                <v-text-field
                    disabled hide-details
                    v-model="currentBotName"
                    class="input-custom"
                ></v-text-field>
                <div class="btn-custom btn-checkout" @click="goToScenario(campaign.bot.id)">
                    <img
                        src="/img/checkout-blue.svg"
                        style="transform: scale(0.95); margin-right: 6px"
                        alt="icon-checkout-bot"
                    />
                    Bot
                </div>
                <div class="btn-custom btn-checkout" @click="goToNLP(campaign.bot.id)">
                    <img
                        src="/img/checkout-blue.svg"
                        style="transform: scale(0.95); margin-right: 6px"
                        alt="icon-checkout-nlp"
                    />
                    NLP
                </div>
            </div>
            <div class="label mt-12">{{ isAdmin() ? $f.tc('bot') : $f.tc('template') }}</div>
            <div class="display-flex align-center">
                <v-autocomplete
                    v-model="model.bot"
                    :items="botList"
                    :rules="formRules.required"
                    item-text="text"
                    item-value="value"
                    class="input-custom"
                ></v-autocomplete>
                <div class="btn-custom btn-checkout" @click="goToScenario(model.bot)">
                    <img
                        src="/img/checkout-blue.svg"
                        style="transform: scale(0.95); margin-right: 6px"
                        alt="icon-checkout-bot-1"
                    />
                    Bot
                </div>
                <div class="btn-custom btn-checkout" @click="goToNLP(model.bot)">
                    <img
                        src="/img/checkout-blue.svg"
                        style="transform: scale(0.95); margin-right: 6px"
                        alt="icon-checkout-nlp-1"
                    />
                    NLP
                </div>
            </div>
        </div>
    </v-form>
</template>

<script>
import FormMixin from '@/modules/fptai/mixins/FormMixin'
import CampaignService from '@/services/campaign.service'
import { mapState } from 'vuex'
import ScenarioService from '@/services/scenario.service'
import RoleMixin from '@/modules/fptai/mixins/RoleMixin'
import lodash from 'lodash'

const defaultModel = {
    title: '',
    bot: '',
}

export default {
    name: 'CampaignInfoConfig',
    mixins: [FormMixin, RoleMixin],
    data () {
        return {
            currentBotName: '',
            oldModel: null,
            scenarioList: [],
            botList: [],
            model: this.$utils.cloneObject(defaultModel),
        }
    },
    computed: {
        ...mapState({
            campaign: state => state.campaign.campaign
        })
    },
    mounted () {
        this.getBotList()
    },
    methods: {
        submit (event) {
            if (event) {
                event.preventDefault()
            }

            if (!this.formValid) {
                this.$refs.form.validate()
                return
            }

            if (lodash.isEqual(this.oldModel, this.model)) {
                this.$appService.toastInfo(this.$f.tc('nothingChanges'))
                return
            }

            this.updateCampaign()
        },
        updateCampaign () {
            this.$appService.showLoading()
            this.$store.dispatch(this.$actionTypes.campaign.UPDATE_CAMPAIGN, {
                campaign: this.campaign,
                model: this.model
            }).then(() => {
                CampaignService.getCampaign(this.campaign.id).then(res => {
                    this.$store.dispatch(this.$actionTypes.campaign.SET_DATA, res.data).then(() => {
                        this.updateModel()
                    })
                })
            }).finally(() => {
                this.$appService.hideLoading()
            })
        },
        updateModel () {
            if (this.campaign?.bot) {
                this.model.bot = this.campaign.bot.id
                this.model.title = this.campaign.title
                this.currentBotName = this.campaign.bot.name
            } else {
                this.model = this.$utils.cloneObject(defaultModel)
                this.currentBotName = ''
            }

            this.oldModel = this.$utils.cloneObject(this.model)
        },
        getBotList () {
            this.$appService.showLoading()
            ScenarioService.search({ page: 1, page_size: 1000 }).then(
                result => {
                    this.scenarioList = result.data.data
                    this.botList = this.scenarioList.map(item => ({ text: item.name, value: item.id }))
                },
                this.$appService.handleRequestError(this.$t('actionFailed', {
                    action: this.$t('load'),
                    item: this.$t('nlp')
                }))
            ).finally(this.$appService.hideLoading)
        },
        goToScenario (scenarioId) {
            window.open(this.$router.resolve(`/scenarios/${scenarioId}`).href)
        },
        goToNLP (scenarioId) {
            let bot = this.scenarioList.find(scenario => scenario.id === scenarioId)
            if (bot) {
                let botHost = process.env.VUE_APP_BOT_HOST || 'https://bot.fpt.ai'
                window.open(`${botHost}/bot/${bot.nlp.code}`)
            } else {
                this.$appService.toastError('You don not have permission to access this bot')
            }
        }
    },
    watch: {
        campaign: {
            deep: true,
            handler: 'updateModel'
        }
    }
}
</script>

<style scoped lang="scss">
::v-deep {
    .v-slider__thumb-label {
        border-radius: 50% 50% 0;
        transform: translateY(-20%) translateY(-12px) translateX(-50%) rotate(45deg);
    }

    .v-text-field {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }

    .v-text-field__details {
        position: absolute;
        right: 0;
        top: 10px;
    }

    .v-select {
        .v-text-field__details {
            right: 40px !important;
        }
    }
}

.title-config {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 48px;
    padding: 0 20px;
    border-bottom: 1px solid #E4EDFA;
}

.label {
    font-family: "open sans semi", serif;
    margin-bottom: 6px;
    font-size: 13px;
}


.config-content {
    padding: 20px;
}

.btn-checkout {
    background: #FFFFFF;
    border: 1px solid #0052CC;
    color: #0052cc;
    margin-left: 8px;

    &:hover {
        background: #d9e5f7;
    }
}

.input-custom {
    position: relative;

    ::v-deep {
        .v-input__slot {
            height: 32px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #D9D9D9;
            outline: none;
            font-size: 14px;
            padding: 6px 12px;
            margin: 0;
            display: flex;
            align-items: center;

            &:before, &:after {
                border: none !important;
            }
        }

        .v-text-field__details {
            right: 20px;
        }
    }
}
</style>
